<template>
  <div class="nav sidebar-list flex-column">
    <template v-for="item in links">
      <template v-if="item.isExpendable && !item.hidden">
        <b-nav-toggle class="sidebar-link" :target="item.expendableId">
          <template #default="{expanded}">
            <b-nav-item :class="{'active': expanded}">
              <component :is="item.icon" class="mr-2"></component>
              {{ item.title }}
              <caret-down-icon v-if="expanded"></caret-down-icon>
              <caret-left-icon v-else></caret-left-icon>
            </b-nav-item>
          </template>
        </b-nav-toggle>
        <b-collapse :id="item.expendableId" accordion="sidebar-accordion">
          <b-nav-item
              v-for="underItem in underlinks[item.underlinksIndex]"
              :key="underItem.route"
              class="sidebar-link sidebar-underlink"
              :to="underItem.route">
            {{ underItem.title }}
          </b-nav-item>
        </b-collapse>
      </template>
      <template v-else-if="!item.hidden">
        <b-nav-toggle target="sidebar-reset">
          <b-nav-item
              :class="'sidebar-link '+ activeItem(item)"
              :to="item.route">
            <component :is="item.icon" :class="'mr-2 ' + activeItem(item)"></component>
            <div :class="activeItem(item)" style="text-align: left;">{{ item.title }}</div>
          </b-nav-item>
        </b-nav-toggle>
        <b-collapse id="sidebar-reset" accordion="sidebar-accordion"></b-collapse>
      </template>
    </template>
  </div>
</template>

<script>
export default {
  name: "SideMenu",
  props: {
    links: {type: Array},
    underlinks: {type: Array},
  },

  computed: {
    activeItem() {
      let domaineActive = this.$route.path.split("/")[1]
      return item => item.routesActiveItem ? item.routesActiveItem.filter(routeActiveItem => routeActiveItem.split("/")[1] === domaineActive).length > 0 ? "activeItem" : "" : ""
    }
  }
}
</script>

<style scoped>
.sidebar-link a {
  color: var(--main-text-color);
  font-family: "WorkSans-Medium", "Arial", sans-serif;
  font-size: var(--title-level-two-font-size);
  font-weight: normal;
  display: flex;
  align-items: center;
  padding: 12px 22px;
}

.sidebar-link a:hover,
.sidebar-link a.router-link-exact-active,
.sidebar-link.child-active a {
  background-color: var(--main-color-background);
  color: var(--main-color);
  -webkit-transition: all 0.25s ease-in-out;
  -moz-transition: all 0.25s ease-in-out;
  -o-transition: all 0.25s ease-in-out;
  transition: all 0.25s ease-in-out;
}

.active a {
  background-color: var(--main-color-background);
  color: var(--main-color);
}

.sidebar-underlink a {
  color: var(--main-white);
  background-color: var(--main-color-active);
}

.sidebar-underlink a:hover,
.sidebar-underlink a.router-link-exact-active,
.sidebar-underlink.child-active a {
  color: var(--main-white);
  background-color: var(--main-color-hover);
}

.navbar-toggler {
  padding: 0;
  border: 0;
  margin-top: 0;
}

.activeItem {
  background-color: var(--main-color-background);
  color: var(--main-color) !important;
}
</style>



// WEBPACK FOOTER //
// src/views/menus/SideMenu.vue